import Welcome from "../../views/public/Welcome";

export default {
    Welcome: {
        component: Welcome,
        path: "/"
    }
};
